import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectFrameDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function FrameSection() {
  const dispatch = useDispatch();
  const frame = useSelector(selectFrameDefaults);

  const handleChange = (value) => {
    const numVal = parseFloat(value);
    if (isNaN(numVal) || numVal < 0) return;
    dispatch(updateDefaults({
      section: 'frame',
      changes: { thickness: numVal },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-field">
        <label>Cerceve Kalinligi (cm)</label>
        <input
          type="number"
          step="0.5"
          min="0"
          value={frame.thickness}
          onChange={e => handleChange(e.target.value)}
        />
      </div>
    </div>
  );
}
